import clsx from 'clsx';
import { ReactComponent as CheckIcon16 } from 'img/icons/onboarding/check_outline_16.svg';
import React, { type ReactNode } from 'react';

import s from './OnboardingPanel.css';

interface IProps {
    icon?: ReactNode;
    title: string;
    position: number;
    tagName?: 'li' | 'div';
    completed?: boolean;
    onClick?(): void;
}

export const Step = ({ title, icon, position, tagName: Tag = 'div', completed, onClick }: IProps) => {
    return (
        <Tag className={clsx(s.step, { [s.completed]: completed, [s.clickable]: !!onClick })} onClick={onClick}>
            {completed ? (
                <span className={s.completeMarker}>
                    <CheckIcon16 />
                </span>
            ) : (
                <span
                    className={clsx(s.stepMarker, {
                        [s.stepMarkerIcon]: !!icon,
                        [s.stepMarkerIcon]: !!icon,
                    })}
                >
                    {icon ? icon : position}
                </span>
            )}
            {title}
        </Tag>
    );
};
